export const errorToLoggableObject = (err: any) => {
  // https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
  // hack to make JavaScript Error exceptions behave as serializable object todo: make this better
  const keys = Object.getOwnPropertyNames(err);
  const loggableObject = keys.reduce((acc, curr) => {
    acc[curr] = err[curr];
    return acc;
  }, {} as { [key: string]: any });

  return loggableObject;
};
